<template>
  <div class="twofactor-container">
    <h2>Enter 2FA Code</h2>
    <form @submit.prevent="verifyToken">
      <input
        v-model="token"
        type="text"
        maxlength="6"
        inputmode="numeric"
        placeholder="Enter your 6-digit code"
        autocomplete="one-time-code"
      />
      <button type="submit" :disabled="verifying">
        {{ verifying ? 'Verifying...' : 'Verify' }}
      </button>
      <p class="error" v-if="error">{{ error }}</p>
    </form>
  </div>
</template>

<script>
import { Buffer } from 'buffer'
import { authenticator } from 'otplib'

window.Buffer = Buffer

export default {
  name: 'TwoFactorView',
  data() {
    return {
      token: '',
      verifying: false,
      error: ''
    }
  },
  methods: {
    verifyToken() {
      this.verifying = true
      this.error = ''

      const secret = sessionStorage.getItem('2faSecret')

      if (!secret) {
        this.error = 'Session expired. Please log in again.'
        this.verifying = false
        return this.$router.push('/login')
      }

      const isValid = authenticator.check(this.token, secret)

      if (isValid) {
        sessionStorage.setItem('2faVerified', 'true')
        this.$router.push('/dashboard')
      } else {
        this.error = 'Invalid code. Please try again.'
        this.verifying = false
      }
    }
  }
}
</script>

<style scoped>
.twofactor-container {
  max-width: 400px;
  margin: 100px auto;
  text-align: center;
}

input {
  font-size: 1.2rem;
  padding: 10px;
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}

button {
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #3dc31f;
  color: white;
  border: none;
  cursor: pointer;
}

button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>